<template>
  <v-container v-if="selectedPortal" fluid>
    <v-row>
      <v-col sm="6">
        <v-row>
          <v-col sm="12">
            <devDraggableMenu :elements="items" />
          </v-col>
        </v-row>
      </v-col>
      <v-divider vertical v-if="!!Object.keys(selectedItem).length"></v-divider>

      <v-col v-if="!!Object.keys(selectedItem).length" class="edit-container">
        <v-form ref="formEdit" v-model="formEdit" class="pr-4 pl-2 pt-2">
          <h2 class="mt-0 mb-3 grey--text text--darken-3">Edição de Menu</h2>

          <v-row>
            <v-col sm="6">
              <v-text-field dense label="Nome" v-model="selectedItem.name" :rules="[rules.required]" />
            </v-col>

            <v-col sm="6">
              <v-text-field dense label="Ícone" v-model="selectedItem.icon" />
            </v-col>

            <v-col sm="6">
              <v-text-field dense label="Procedure" v-model="selectedItem.procedure" />
            </v-col>

            <v-col sm="6">
              <v-text-field
                dense
                label="Redirect"
                v-model="selectedItem.redirect"
                hint="se desejar ter um link externo, adicione conforme exemplo: http://www.exemplo.com"
              />
            </v-col>

            <v-col sm="6">
              <v-text-field dense label="Page" v-model="selectedItem.page" />
            </v-col>

            <v-col sm="6">
              <v-select :items="modes" dense label="Mode" v-model="selectedItem.modeId" item-text="nm_tp_page_mode" item-value="id_tp_page_mode" />
            </v-col>

            <v-col sm="12">
              <v-text-field dense label="Parâmetros" v-model="selectedItem.parameters" />
            </v-col>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-col v-on="on" sm="12" class="pt-0 pr-0 mr-0 mb-0 pb-0">
                  <v-switch
                    dense
                    v-model="selectedItem.suspended"
                    :disabled="selectedItem.parentId !== null"
                    label="Menu Suspenso?"
                    color="primary"
                    class="mt-0 mb-0"
                    hide-details
                  />
                </v-col>
              </template>

              <span
                v-text="
                  selectedItem.parentId !== null
                    ? 'Não é possivel cadastrar menu suspenso quando está dentro de outro menu.'
                    : 'Quando ativo essa flag, o menu ficará na parte superior do site.'
                "
              ></span>
            </v-tooltip>
            <v-col sm="12" class="d-flex justify-end">
              <v-btn :disabled="!formEdit" class="mr-2" color="grey darken-3" dark @click="handleUpdateMenu">
                <v-icon class="mr-2">done_all</v-icon>Salvar
              </v-btn>

              <v-btn color="grey darken-3" outlined @click="handleCancelItem"> <v-icon class="mr-2">reply_all</v-icon>Cancelar </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>

    <v-layout class="actions-menu-dev" v-if="showActions">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" fab color="green" :dark="enableSave" :disabled="!enableSave" @click="handleSaveOrderMenu">
            <v-icon>save</v-icon>
          </v-btn>
        </template>

        <span>Salvar Ordenação</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" fab color="blue darken-3" :dark="enableAdd" :disabled="!enableAdd" @click="addItem">
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Novo Menu</span>
      </v-tooltip>
    </v-layout>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-form ref="formNew" v-model="formNew">
        <v-card>
          <v-card-title class="px-4 d-flex justify-space-between">
            <span class="text-subtitle-1 font-weight-medium">Novo menu</span>

            <v-icon color="grey darken-3" :size="20" @click="closeDialog">close</v-icon>
          </v-card-title>

          <v-divider></v-divider>

          <v-container fluid class="mt-4 px-4">
            <v-row>
              <v-col sm="6">
                <v-text-field dense hide-details label="Nome" v-model="newItem.name" :rules="[rules.required]" />
              </v-col>

              <v-col sm="6">
                <v-select
                  :items="parents"
                  label="Menu pai"
                  item-text="name"
                  item-value="id"
                  dense
                  clearable
                  v-model="newItem.parentId"
                  @click:clear="newItem.parentId = ''"
                  hide-details
                />
              </v-col>

              <v-col sm="6">
                <v-text-field hide-details dense label="Ícone" v-model="newItem.icon" />
              </v-col>

              <v-col sm="6">
                <v-text-field
                  hide-details
                  dense
                  label="Redirect"
                  v-model="newItem.redirect"
                  hint="se desejar ter um link externo, adicione conforme exemplo: http://www.exemplo.com"
                />
              </v-col>

              <v-col sm="5">
                <v-text-field hide-details dense label="Page" v-model="newItem.page" />
              </v-col>

              <v-col sm="3">
                <v-select
                  hide-details
                  :items="modes"
                  dense
                  label="Modo"
                  v-model="newItem.mode"
                  item-text="nm_tp_page_mode"
                  item-value="id_tp_page_mode"
                />
              </v-col>

              <v-col sm="4">
                <v-text-field hide-details dense label="Procedure" v-model="newItem.procedure" />
              </v-col>

              <v-col sm="12">
                <v-text-field hide-details dense label="Parâmetros" v-model="newItem.parameters" />
              </v-col>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-col v-on="on" sm="12" class="pt-0 pt-0 pr-0 mr-0 mb-0 pb-0">
                    <v-switch
                      dense
                      v-model="newItem.suspended"
                      :disabled="!!newItem.parentId"
                      label="Menu Suspenso?"
                      color="primary"
                      class="mt-0 mb-0"
                      hide-details
                    />
                  </v-col>
                </template>

                <span
                  v-text="
                    newItem.parentId
                      ? 'Não é possivel cadastrar menu suspenso quando está dentro de outro menu.'
                      : 'Quando ativo essa flag, o menu ficará na parte superior do site.'
                  "
                ></span>
              </v-tooltip>
            </v-row>
          </v-container>

          <v-card-actions>
            <v-spacer />
            <v-btn color="grey darken-3" @click="handleAddItem" :dark="formNew" :disabled="!formNew">Salvar</v-btn>
            <v-btn color="error" @click="closeDialog">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>

  <v-container class="fill-height" v-else>
    <v-row>
      <v-col cols="12" class="d-flex justify-center align-center">
        <p class="text-h6 font-weight-bold text--disabled">Selecione um ambiente/portal para continuar</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Swal from 'sweetalert2';
import * as HANDLERS from '@/helpers/types/handlers';
import { createMenu, getPageMode, updateMenu, deleteMenu, saveOrderMenu } from '@/services/dev';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [devComponentMixin],

  components: {
    devDraggableMenu: () => import('@/components/dev/dev-draggable-menu')
  },

  events: {
    [HANDLERS.REMOVE_ITEM]: 'removeItem',
    [HANDLERS.SHOW_ITEM]: 'showItem',
    [HANDLERS.ADD_ITEM]: 'addItem',
    [HANDLERS.CHANGE_ORDER]: 'changeOrder'
  },

  data() {
    return {
      rules: {
        required: v => !!v || 'Este campo é obrigatório'
      },
      formEdit: false,
      formNew: false,
      fab: false,
      dialog: false,
      modes: [],
      showActions: true,
      enableSave: false,
      enableAdd: true,
      newItem: {
        name: null,
        icon: null,
        redirect: null,
        page: null,
        children: [],
        mode: null,
        parentId: null,
        procedure: '',
        parameters: '',
        suspended: false
      }
    };
  },

  async mounted() {
    this.handleGetPageMode();
    this.$store.dispatch('dev/getMenus');
    this.$store.dispatch('dev/setSelectedItem', {});
  },

  computed: {
    items() {
      return this.$store.getters['dev/getNavItems'];
    },

    selectedItem() {
      return this.$store.getters['dev/getSelectedItem'];
    },

    parents() {
      return this.$store.getters['dev/getParents'];
    }
  },

  methods: {
    async handleGetPageMode() {
      const { data } = await getPageMode();

      this.modes = data;
    },

    changeOrder(event) {
      this.enableSave = true;
      this.enableAdd = false;
    },

    async handleSaveOrderMenu() {
      const { status } = await saveOrderMenu(this.selectedPortal.portalId, this.items);

      if (status === 204 || status === 200 || data) {
        this.showMessage('success', 'Menu ordenado com sucesso!');
        this.enableSave = false;
        this.enableAdd = true;
      }
    },

    handleCancelItem() {
      this.$store.dispatch('dev/setSelectedItem', {});

      this.showActions = true;
    },

    async handleUpdateMenu() {
      if (!this.$refs.formEdit.validate(true)) return;

      const { status } = await updateMenu(this.selectedItem, this.selectedPortal.portalId);

      if (status === 204 || status === 200 || data) {
        this.$store.dispatch('dev/getMenus');
      }

      this.$store.dispatch('dev/setSelectedItem', {});

      this.showMessage('success', 'Menu alterado com sucesso!');

      this.showActions = true;
    },

    async removeItem(item) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: `v-btn v-size--default success`,
          cancelButton: `v-btn v-size--default error error`
        },

        buttonsStyling: false
      });

      let title, text;

      if (!!item.children) {
        title = `Atenção`;
        text = `Deseja realmente excluir o menu e todos os seus dependentes?`;
      } else {
        title = `Deseja realmente excluir o menu?`;
      }

      const result = await swalWithBootstrapButtons.fire({
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK ',
        reverseButtons: true,
        cancelButtonText: 'Cancelar'
      });

      if (result.value) {
        const { status } = await deleteMenu(item.id, this.selectedPortal.portalId);

        if (status === 204 || status === 200 || data) {
          this.$store.dispatch('dev/getMenus');
          this.showMessage('success', 'Menu excluído com sucesso!');
          this.$store.dispatch('dev/setSelectedItem', {});
        }
      }
    },

    showItem(item) {
      this.$store.dispatch('dev/setSelectedItem', item);
      this.showActions = false;
      this.drawer = true;
    },

    addItem(item) {
      if (item.id) {
        this.newItem.parentId = item.id;
      } else {
        this.newItem.parentId = null;
      }

      this.dialog = true;
    },

    async handleAddItem() {
      if (!this.$refs.formNew.validate(true)) return;

      const { data, status } = await createMenu(this.newItem, this.selectedPortal.portalId);

      if (status === 204 || status === 200 || data) {
        this.$store.dispatch('dev/getMenus');
      }

      this.dialog = false;
      this.enableAdd = true;

      this.clearNewitem();

      this.showMessage('success', 'Menu adicionado com sucesso!');
    },

    closeDialog() {
      this.clearNewitem();
      this.dialog = false;
      this.$refs.formNew.reset();
    },

    clearNewitem() {
      this.newItem = {
        name: null,
        icon: null,
        redirect: null,
        page: null,
        children: [],
        procedure: '',
        mode: null,
        parentId: null,
        parameters: '',
        suspended: false
      };
    },

    showMessage(type, message) {
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
      });

      Toast.fire({
        icon: type,
        title: message
      });
    }
  }
};
</script>

<style lang="scss">
.actions-menu-dev {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 5;

  .v-btn {
    margin: 10px;
  }
}

.edit-container {
  position: relative;

  form {
    position: fixed;
  }
}
</style>
